import type { UserDepositBonusGetPayload } from '@repo/database/src/types';

export type UserDepositBonusWithBonus = UserDepositBonusGetPayload<{ include: { depositBonus: true } }>;

export interface UserDepositBonusWithBonusProgress extends UserDepositBonusWithBonus {
  currentRakeProgress: number;
  rakeTarget: number;
}

export interface ApplyBonusToUserDto {
  depositBonusId: string;
  startDate: string;
  depositAmount: number;
  userId: string;
}
